import React, { useEffect } from "react";
import ROUTES, { RenderRoutes } from "./routes/routes";
import { connect } from "react-redux";
import "./App.css";
import { RootState } from "./redux/rootReducers";
import {
  resetAuthError,
  resetAuthSuccess,
  resetAuthFetching,
} from "./redux/auth";
import { resetInvoicingFetching } from "./redux/invoicing";
import { resetServicesFetching } from "./redux/services";
import { resetListingFetching } from "./redux/listing";
import { resetOpenItemsFetching } from "./redux/openItems";
import { GetMaintenanceTypes } from "./redux/maintenance/maintenanceTypes";
import { getMaintenanceDataAction } from "./redux/maintenance";

type AppProps = {
  token: string | null;
  dispatchResetAuthError: () => void;
  dispatchResetAuthFetching: () => void;
  dispatchResetServicesFetching: () => void;
  dispatchResetInvoicingFetching: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetListingFetching: () => void;
  dispatchResetOpenItemsFetching: () => void;
  isMaintenance?: number;
  maintenanceData?: GetMaintenanceTypes;
  dispatchGetMaintenanceData: () => void;
};

function App({
  token,
  dispatchResetAuthError,
  dispatchResetAuthFetching,
  dispatchResetInvoicingFetching,
  dispatchResetServicesFetching,
  dispatchResetOpenItemsFetching,
  dispatchResetListingFetching,
  dispatchGetMaintenanceData,
  isMaintenance,
  maintenanceData,
}: AppProps) {
  const resetFetching = () => {
    dispatchResetAuthFetching();
    dispatchResetInvoicingFetching();
    dispatchResetServicesFetching();
    dispatchResetOpenItemsFetching();
    dispatchResetListingFetching();
  };

  useEffect(() => {
    dispatchResetAuthError();
    window.addEventListener("beforeunload", resetFetching);

    return () => {
      window.removeEventListener("beforeunload", resetFetching);
    };
  }, []);

  useEffect(() => {
    dispatchGetMaintenanceData();
  }, []);

  return (
    <div className="main">
      {/* {
        isMaintenance === 1 ? <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ede6fc',
          height: '50px',
          width: '100%',
          color: '#744bd1',
          fontWeight: 'bolder'
        }}
        >
          <span>Upcoming maintenance is scheduled on Saturday June 15th at 3:30PM (Your time) and Finac will be unavailable for 2 hour. Be sure to save your work.</span>
        </div> : null
      } */}
      <RenderRoutes token={token} routes={ROUTES} />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.auth.error,
  isMaintenance: state.maintenance.isMaintenance,
  maintenanceData: state.maintenance.maintenanceData,
});

const matchDispatchToProps = (dispatch: any) => ({
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetAuthFetching: () => dispatch(resetAuthFetching()),
  dispatchResetServicesFetching: () => dispatch(resetServicesFetching()),
  dispatchResetInvoicingFetching: () => dispatch(resetInvoicingFetching()),
  dispatchResetListingFetching: () => dispatch(resetListingFetching()),
  dispatchResetOpenItemsFetching: () => dispatch(resetOpenItemsFetching()),
  dispatchGetMaintenanceData: () => dispatch(getMaintenanceDataAction()),
});

export default connect(mapStateToProps, matchDispatchToProps)(App);
